import Vue from 'vue';

import VueRouter from 'vue-router';

import { PAGES } from '@/constants/pages';
import Accesses from '@/pages/account/accesses/Accesses';
import Account from '@/pages/account/Account';
import AccountBalance from '@/pages/account/AccountBalance';
import AccountDocuments from '@/pages/account/AccountDocuments';
import AccountInvoices from '@/pages/account/AccountInvoices';
import Dealers from '@/pages/account/dealers/Dealers';
import Employees from '@/pages/account/employees/Employees';
import Markup from '@/pages/account/markup/Markup';
import NewOrder from '@/pages/account/new-order/NewOrder';
import Notifications from '@/pages/account/notifications/Notifications';
import Orders from '@/pages/account/orders/Orders';
import OrdersDealer from '@/pages/account/orders/OrdersDealer';
import OrdersRetail from '@/pages/account/orders/OrdersRetail';
import OrdersSupplier from '@/pages/account/orders/OrdersSupplier';
import Payers from '@/pages/account/payers/Payers';
import Profile from '@/pages/account/profile/Profile';
import ReclamationsDealers from '@/pages/account/reclamations/ReclamationsDealers';
import ReclamationsSupplier from '@/pages/account/reclamations/ReclamationsSupplier';
import ReportsMaterialsZgi from '@/pages/account/reports/materials-zgi/MaterialsZgi';
import ReportsOrders from '@/pages/account/reports/orders/ReportsOrders';
import ReportSpecialPrices from "@/pages/account/reports/special-prices";
import Reports from '@/pages/account/reports/Reports';
import ReportsSelling from '@/pages/account/reports/selling/ReportsSelling';
import ReportsShippings from "@/pages/account/reports/shippings";
import Warehouse from '@/pages/account/warehouse/Warehouse';
import PhotoGallery from '@/pages/account/photo-gallery';
import Customizer from '@/pages/customizer/Customizer';
import PartnerNew from '@/pages/PartnerNew';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'root',
    component: Customizer,
  },
  {
    path: '/edit-order/:uuid',
    name: 'edit-order',
    component: Customizer,
    props: true
  },
  {
    path: '/dealers/:uuid/register',
    name: 'register',
    component: PartnerNew,
    props: true
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    children: [
      {
        path: PAGES.profile.path,
        name: PAGES.profile.name,
        component: Profile,
      },
      {
        path: PAGES.documents.path,
        name: PAGES.documents.name,
        component: AccountDocuments,
      },
      {
        path: PAGES.payers.path,
        name: PAGES.payers.name,
        component: Payers,
      },
      {
        path: 'access-rights',
        name: 'access-rights',
        component: Accesses,
      },
      {
        path: PAGES.reports.path,
        name: PAGES.reports.name,
        component: Reports,
      },
      {
        path: PAGES.orders.new_order.path,
        name: PAGES.orders.new_order.name,
        component: NewOrder,
      },
      {
        path: PAGES.orders.path,
        name: PAGES.orders.name,
        component: Orders,
        redirect: {
          name: PAGES.orders.retail.name
        },
        children: [
          {
            path: PAGES.orders.retail.path,
            name: PAGES.orders.retail.name,
            component: OrdersRetail,
          },
          {
            path: PAGES.orders.supplier.path,
            name: PAGES.orders.supplier.name,
            component: OrdersSupplier,
          },
          {
            path: PAGES.orders.dealer.path,
            name: PAGES.orders.dealer.name,
            component: OrdersDealer,
          },
        ],
      },
      {
        path: PAGES.reclamations_supplier.path,
        name: PAGES.reclamations_supplier.name,
        component: ReclamationsSupplier,
      },
      {
        path: PAGES.reclamations_dealers.path,
        name: PAGES.reclamations_dealers.name,
        component: ReclamationsDealers,
      },
      {
        path: PAGES.warehouse.path,
        name: PAGES.warehouse.name,
        component: Warehouse,
      },
      {
        path: PAGES.markup.path,
        name: PAGES.markup.name,
        component: Markup,
      },
      {
        path: PAGES.balance.path,
        name: PAGES.balance.name,
        component: AccountBalance,
      },
      {
        path: PAGES.invoices.path,
        name: PAGES.invoices.name,
        component: AccountInvoices
      },
      {
        path: PAGES.report_selling.path,
        name: PAGES.report_selling.name,
        component: ReportsSelling,
      },
      {
        path: PAGES.shippings.path,
        name: PAGES.shippings.name,
        component: ReportsShippings,
      },
      {
        path: PAGES.reports_orders.path,
        name: PAGES.reports_orders.name,
        component: ReportsOrders,
      },
      {
        path: PAGES.reports_by_materials_zgi.path,
        name: PAGES.reports_by_materials_zgi.name,
        component: ReportsMaterialsZgi,
      },
      {
        path: PAGES.special_prices.path,
        name: PAGES.special_prices.name,
        component: ReportSpecialPrices,
      },
      {
        path: PAGES.notifications.path,
        name: PAGES.notifications.name,
        component: Notifications,
      },
      {
        path: PAGES.employees.path,
        name: PAGES.employees.name,
        component: Employees,
      },
      {
        path: PAGES.dealers.path,
        name: PAGES.dealers.name,
        component: Dealers,
      },
      {
        path: 'wholesale-orders/:uuid/edit',
        name: PAGES.wholesale.name,
        component: NewOrder,
      },
      {
        path: PAGES.photoGallery.path,
        name: PAGES.photoGallery.name,
        component: PhotoGallery
      }
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit('common/updateRoute', to);
  next();
});

const DEFAULT_TITLE = 'Personal area customizer';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
